export default "__VITE_ASSET__qhvChEoj__"